<template>
  <div class="table-container">
    <div v-if="isUnassigned && manualLeads" class="d-flex justify-content-end mb-3 mx-2">
      <button type="button" class="btn btn-primary" @click="openCreateModal">
        <i class="ti ti-square-rounded-plus"></i>Add
      </button>
    </div>
    <hr v-if="isUnassigned">
    <a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false"
      :row-selection="rowSelection">
      <!-- Template for table body cells -->
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'Name'">
          <h2 class="table-avatar d-flex align-items-center">
            <router-link
              :to="{ path: '/crm/organisation-details', query: { ter_Id: record.ter_Id, org_Id: record.key } }"
              class="profile-split d-flex flex-column">
              {{ record.organisation_name }}
            </router-link>
          </h2>
        </template>
        <template v-else-if="column.key === 'Status'">
          <div>
            <span :class="record.statusclass">{{ record.status }}</span>
          </div>
        </template>
        <template v-else-if="column.key === 'Phone'">
          <div>
            {{ record.phone }}
          </div>
        </template>
        <template v-else-if="column.key === 'action'">
          <div class="icon-field d-flex gap-1 flex-wrap">
            <button v-if="!isClosed" type="button" class="btn table_action_btn" @click="viewMore(record.key)"><i
                class="ti ti-eye text-blue-light"></i>
              View</button>
            <button v-if="isUnassigned" type="button" class="btn table_action_btn"
              @click="openEditModal(record.key)"><i class="ti ti-edit"></i>
              Edit</button>
            <button v-if="isUnassigned" type="button" class="btn table_action_btn"
              @click="openCloseModal(record.key)"><i class="ti ti-x text-danger"></i>
              Close</button>
            <button v-if="isClosed" type="button" class="btn table_action_btn" @click="handleUnassign(record.key)"><i
                class="ti ti-arrow-back-up"></i>
              Unassign</button>
          </div>
        </template>
      </template>
    </a-table>
  </div>

  <!-- Fixed Pagination -->
  <div class="pagination-container" v-if="data.length > 0">
    <a-pagination :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total"
      @change="handleTableChange" class="d-flex" showSizeChanger :pageSizeOptions="pageSizeOptions" />
  </div>

  <div ref="lead" class="modal fade" id="lead_model" tabindex="-1" role="dialog" aria-labelledby="leadLable"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered lead-model">
      <div class="modal-content">
        <div class="d-flex justify-content-between">
          <h4 class=""></h4>
          <div class="modal-header border-0 m-0 justify-content-end">
            <button class="btn-close" id="close-btn" data-bs-dismiss="modal" aria-label="Close">
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <div class="modal-body confirm">
          <!-- <div class="row"> -->
          <!-- <div class="col-md-4" v-for="(value, key) in row" :key="key">
              <div class="form-wrap">
                <label class="col-form-label">{{ key }}</label>
                <input type="text" class="form-control" :value="value" />
              </div>
            </div> -->
          <div class="mb-2">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in row" :key="key">
                  <td>{{ key }}</td>
                  <td>
                    {{ row[key] }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- </div> -->
          <div class="d-flex justify-content-end">
            <button class="btn btn-outline-secondary cancel-btn" @click="cancel_change">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Close Lead Modal -->
  <div ref="closeLeadModalEl" class="modal fade" id="close_lead_modal" tabindex="-1" role="dialog"
    aria-labelledby="closeLeadLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="closeLeadLabel">Close Lead</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click="closeCloseModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Lead Closed Reason</label>
            <select v-model="closeForm.closed_reason" class="form-select" required>
              <option value="">Select reason...</option>
              <option v-for="opt in leadClosedReasons" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="closeCloseModal">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="!closeForm.closed_reason"
            @click="submitCloseLead">Submit</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit Lead Modal -->
  <div ref="editLeadModalEl" class="modal fade" id="edit_lead_modal" tabindex="-1" role="dialog"
    aria-labelledby="editLeadLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered lead-model">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editLeadLabel">Edit Lead</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click="closeEditModal"></button>
        </div>
        <form @submit.prevent="submitEditLead">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Company</label>
              <input v-model="editForm.company" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['company'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['company']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Postcode</label>
              <input v-model="editForm.postcode" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['postcode'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['postcode']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input v-model="editForm.name" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['name'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['name']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Phone</label>
              <input v-model="editForm.phone" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['phone'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['phone']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input v-model="editForm.email" type="email" class="form-control" />
              <div v-if="fieldError(editErrors, ['email'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['email']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Gas</label>
              <input v-model="editForm.gas" type="text" class="form-control" placeholder="MPRN" />
              <div v-if="fieldError(editErrors, ['gas'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['gas']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Electricity</label>
              <input v-model="editForm.electricity" type="text" class="form-control" placeholder="MPAN bottom" />
              <div v-if="fieldError(editErrors, ['electricity'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['electricity']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Contract End Date</label>
              <input v-model="editForm.contract_end_date" type="date" class="form-control" />
              <div v-if="fieldError(editErrors, ['contract_end_date'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['contract_end_date']) }}
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label">Address</label>
              <input v-model="editForm.address" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['address'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['address']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Service Type</label>
              <input v-model="editForm.service_type" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['service_type'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['service_type']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Current Supplier</label>
              <vue-select
                :options="supplierOptions"
                v-model="editForm.current_supplier"
                :settings="supplierSelectSettingsForEdit"
                placeholder="Select....."
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
              />
              <div v-if="fieldError(editErrors, ['current_supplier'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['current_supplier']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Source</label>
              <input v-model="editForm.source" type="text" class="form-control" />
              <div v-if="fieldError(editErrors, ['source'])" class="text-danger small mt-1">
                {{ fieldError(editErrors, ['source']) }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="closeEditModal">Cancel</button>
          <button type="submit" class="btn btn-primary">Save Changes</button>
        </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Create Lead Modal -->
  <div ref="createLeadModalEl" class="modal fade" id="create_lead_modal" tabindex="-1" role="dialog"
    aria-labelledby="createLeadLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered lead-model">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="createLeadLabel">Create Lead</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click="closeCreateModal"></button>
        </div>
        <form @submit.prevent="submitCreateLead">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Company</label>
              <input v-model="createForm.company" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['company'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['company']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Postcode</label>
              <input v-model="createForm.postcode" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['postcode'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['postcode']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Name <span class="text-danger">*</span></label>
              <input v-model="createForm.name" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['name'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['name']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Phone</label>
              <input v-model="createForm.phone" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['phone'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['phone']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Email</label>
              <input v-model="createForm.email" type="email" class="form-control" />
              <div v-if="fieldError(createErrors, ['email'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['email']) }}
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label">Gas <span class="text-muted small">(max {{ MAX_METERS }})</span></label>
              <div class="utility-row-labels d-flex gap-2 mb-2">
                <div class="meter-add-slot flex-shrink-0"></div>
                <div class="utility-input-col small text-muted">MPRN</div>
                <div class="utility-supplier-col small text-muted">Current Supplier</div>
                <div class="utility-date-col small text-muted">Contract End Date</div>
                <div class="utility-remove-col"></div>
              </div>
              <div v-for="(g, idx) in createForm.gas_list" :key="'cg' + idx" class="meter-row d-flex align-items-center gap-2 mb-2">
                <div class="meter-add-slot flex-shrink-0">
                  <button v-if="idx === createForm.gas_list.length - 1" type="button" class="btn btn-sm btn-outline-primary meter-add-btn"
                    :disabled="createForm.gas_list.length >= MAX_METERS"
                    title="Add gas number"
                    @click="addMeterRow('gas_list')">
                    <i class="ti ti-plus"></i>
                  </button>
                </div>
                <div class="utility-input-col">
                  <input v-model="g.value" type="text" class="form-control" placeholder="MPRN" />
                  <div v-if="fieldError(createErrors, [`gas.${idx}`, `gas_list.${idx}`, `gas_list[${idx}]`, `gas_list.${idx}.value`, `gas_list[${idx}].value`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`gas.${idx}`, `gas_list.${idx}`, `gas_list[${idx}]`, `gas_list.${idx}.value`, `gas_list[${idx}].value`]) }}
                  </div>
                </div>
                <div class="utility-supplier-col">
                  <vue-select
                    :options="supplierOptions"
                    v-model="g.current_supplier"
                    :settings="supplierSelectSettingsForCreate"
                    placeholder="Select....."
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                  />
                  <div v-if="fieldError(createErrors, [`gas_list.${idx}.current_supplier`, `gas_list[${idx}].current_supplier`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`gas_list.${idx}.current_supplier`, `gas_list[${idx}].current_supplier`]) }}
                  </div>
                </div>
                <div class="utility-date-col">
                  <input v-model="g.contract_end_date" type="date" class="form-control" />
                  <div v-if="fieldError(createErrors, [`gas_list.${idx}.contract_end_date`, `gas_list[${idx}].contract_end_date`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`gas_list.${idx}.contract_end_date`, `gas_list[${idx}].contract_end_date`]) }}
                  </div>
                </div>
                <button v-if="createForm.gas_list.length > 1" type="button" class="btn btn-sm btn-outline-danger flex-shrink-0 utility-remove-col"
                  title="Remove"
                  @click="removeMeterRow('gas_list', idx)">
                  <i class="ti ti-x"></i>
                </button>
              </div>
              <div v-if="fieldError(createErrors, ['gas'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['gas']) }}
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label">Electricity <span class="text-muted small">(max {{ MAX_METERS }})</span></label>
              <div class="utility-row-labels d-flex gap-2 mb-2">
                <div class="meter-add-slot flex-shrink-0"></div>
                <div class="utility-input-col small text-muted">MPAN bottom</div>
                <div class="utility-supplier-col small text-muted">Current Supplier</div>
                <div class="utility-date-col small text-muted">Contract End Date</div>
                <div class="utility-remove-col"></div>
              </div>
              <div v-for="(e, idx) in createForm.electricity_list" :key="'ce' + idx" class="meter-row d-flex align-items-center gap-2 mb-2">
                <div class="meter-add-slot flex-shrink-0">
                  <button v-if="idx === createForm.electricity_list.length - 1" type="button" class="btn btn-sm btn-outline-primary meter-add-btn"
                    :disabled="createForm.electricity_list.length >= MAX_METERS"
                    title="Add electricity number"
                    @click="addMeterRow('electricity_list')">
                    <i class="ti ti-plus"></i>
                  </button>
                </div>
                <div class="utility-input-col">
                  <input v-model="e.value" type="text" class="form-control" placeholder="MPAN bottom" />
                  <div v-if="fieldError(createErrors, [`electricity.${idx}`, `electricity_list.${idx}`, `electricity_list[${idx}]`, `electricity_list.${idx}.value`, `electricity_list[${idx}].value`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`electricity.${idx}`, `electricity_list.${idx}`, `electricity_list[${idx}]`, `electricity_list.${idx}.value`, `electricity_list[${idx}].value`]) }}
                  </div>
                </div>
                <div class="utility-supplier-col">
                  <vue-select
                    :options="supplierOptions"
                    v-model="e.current_supplier"
                    :settings="supplierSelectSettingsForCreate"
                    placeholder="Select....."
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                  />
                  <div v-if="fieldError(createErrors, [`electricity_list.${idx}.current_supplier`, `electricity_list[${idx}].current_supplier`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`electricity_list.${idx}.current_supplier`, `electricity_list[${idx}].current_supplier`]) }}
                  </div>
                </div>
                <div class="utility-date-col">
                  <input v-model="e.contract_end_date" type="date" class="form-control" />
                  <div v-if="fieldError(createErrors, [`electricity_list.${idx}.contract_end_date`, `electricity_list[${idx}].contract_end_date`])" class="text-danger small mt-1">
                    {{ fieldError(createErrors, [`electricity_list.${idx}.contract_end_date`, `electricity_list[${idx}].contract_end_date`]) }}
                  </div>
                </div>
                <button v-if="createForm.electricity_list.length > 1" type="button" class="btn btn-sm btn-outline-danger flex-shrink-0 utility-remove-col"
                  title="Remove"
                  @click="removeMeterRow('electricity_list', idx)">
                  <i class="ti ti-x"></i>
                </button>
              </div>
              <div v-if="fieldError(createErrors, ['electricity'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['electricity']) }}
              </div>
            </div>
            <div class="col-md-12 mb-3">
              <label class="form-label">Address</label>
              <input v-model="createForm.address" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['address'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['address']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Service Type</label>
              <input v-model="createForm.service_type" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['service_type'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['service_type']) }}
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Source</label>
              <input v-model="createForm.source" type="text" class="form-control" />
              <div v-if="fieldError(createErrors, ['source'])" class="text-danger small mt-1">
                {{ fieldError(createErrors, ['source']) }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" @click="closeCreateModal">Cancel</button>
          <button type="submit" class="btn btn-primary">Create Lead</button>
        </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import {
  ref,
  onMounted,
  watchEffect,
  computed,
  watch
} from 'vue';
import {
  useStore
} from "vuex";
import {
  useRouter
} from 'vue-router';
import { Row, message } from 'ant-design-vue';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import { changeFormate } from '@/util';

export default {
  props: {
    searchQuery: String,
    filters: Object,
    isAssigned: Boolean,
    isClosed: { type: Boolean, default: false },
    manualLeads: { type: Boolean, default: false },
  },
  data() {
    return {
      data: [],
      rowSelection: {
        onChange: () => { },
        onSelect: () => { },
        onSelectAll: () => { },
      },
    };
  },

  setup(props) {
    const store = useStore();
    const router = useRouter();
    const MAX_METERS = 10;

    // Suppliers dropdown (send supplier name string in payload, not id)
    // Match "meter opp" select component: vue3-select2-component (<vue-select>)
    // It uses options like { id, text } and v-model stores selected `id`.
    store.dispatch('price/fetchSuppliers').catch(() => {});
    const supplierOptions = computed(() => {
      const raw = store.getters['price/getSuppliers'] || [];
      const names = raw
        .map((s) => (typeof s === 'string' ? s : (s?.name ?? '')))
        .map((s) => String(s).trim())
        .filter(Boolean);
      const uniqueSorted = Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
      return [
        { id: '', text: 'Select.....', original: null },
        ...uniqueSorted.map((name) => ({ id: name, text: name, original: name })),
      ];
    });

    // Ensure Select2 search works reliably (especially inside Bootstrap modals)
    const supplierSelectSettingsForEdit = computed(() => ({
      width: '100%',
      dropdownParent: editLeadModalEl.value || undefined,
      minimumResultsForSearch: 0,
      placeholder: 'Select.....',
      allowClear: true,
    }));
    const supplierSelectSettingsForCreate = computed(() => ({
      width: '100%',
      dropdownParent: createLeadModalEl.value || undefined,
      minimumResultsForSearch: 0,
      placeholder: 'Select.....',
      allowClear: true,
    }));

    const createErrors = ref({});
    const editErrors = ref({});

    const normalizeBackendErrors = (payloadOrError) => {
      const data = payloadOrError?.response?.data || payloadOrError || {};
      const rawErrors = data?.errors;
      const out = {};

      if (rawErrors && typeof rawErrors === 'object') {
        Object.entries(rawErrors).forEach(([key, val]) => {
          if (Array.isArray(val)) {
            out[key] = val.filter(Boolean).join(' ');
          } else if (typeof val === 'string') {
            out[key] = val;
          } else if (val != null) {
            out[key] = String(val);
          }
        });
      }

      const msg = typeof data?.message === 'string' ? data.message : '';
      return { fieldErrors: out, message: msg };
    };

    const fieldError = (errorsRefOrObj, keys) => {
      // Vue templates auto-unwrap refs, so we may receive either:
      // - a Ref<{...}> (script usage)
      // - a plain object (template usage)
      const bag = errorsRefOrObj?.value ?? errorsRefOrObj ?? {};
      for (const k of keys) {
        if (bag?.[k]) return bag[k];
      }
      return '';
    };

    const meterListToPayloadArray = (list) =>
      (list || [])
        .map((entry) => (typeof entry === 'object' ? entry?.value : entry))
        .map((s) => String(s).trim())
        .filter(Boolean)
        .slice(0, MAX_METERS);

    const meterListToDetailedPayloadArray = (list) =>
      (list || [])
        .map((entry) => ({
          value: String(entry?.value ?? '').trim(),
          current_supplier: String(entry?.current_supplier ?? '').trim(),
          contract_end_date: String(entry?.contract_end_date ?? '').trim(),
        }))
        .filter((entry) => entry.value)
        .slice(0, MAX_METERS);

    const emptyMeterRow = () => ({
      value: '',
      current_supplier: '',
      contract_end_date: '',
    });

    /** For edit form: show arrays / JSON arrays from API as one comma-separated line. */
    const meterValueToSingleFieldString = (value) => {
      if (value == null || value === '') return '';
      if (Array.isArray(value)) {
        return value.map((v) => String(v).trim()).filter(Boolean).join(', ');
      }
      if (typeof value === 'string') {
        const t = value.trim();
        if (!t) return '';
        try {
          const parsed = JSON.parse(t);
          if (Array.isArray(parsed)) {
            return parsed.map((v) => String(v).trim()).filter(Boolean).join(', ');
          }
        } catch (_) {
          /* plain string */
        }
        return t;
      }
      return String(value);
    };

    const addMeterRow = (key) => {
      if (createForm.value[key].length >= MAX_METERS) return;
      createForm.value[key].push(emptyMeterRow());
    };

    const removeMeterRow = (key, index) => {
      const arr = createForm.value[key];
      if (arr.length <= 1) {
        arr[0] = emptyMeterRow();
        return;
      }
      arr.splice(index, 1);
    };

    const data = ref([]);
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
    });

    const columns = ref([
      {
        title: "Sr No.",
        dataIndex: "sr_no",
        sorter: {
          compare: (a, b) => {
            a = a.sr_no;
            b = b.sr_no;
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      {
        title: "Lead No.",
        dataIndex: "lead_no",
        sorter: {
          compare: (a, b) => {
            a = a.lead_no;
            b = b.lead_no;
            return a > b ? -1 : b > a ? 1 : 0;
          },
        }
      },
      {
        title: "Created At",
        dataIndex: "created_at",
        key: "created_at",
        sorter: {
          compare: (a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return dateB - dateA;
          },
        },
      },
      {
        title: "Organisation Name",
        dataIndex: "organisation_name",
        key: "OrgName",
        sorter: {
          compare: (a, b) => {
            a = a.organisation_name.toLowerCase();
            b = b.organisation_name.toLowerCase();
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      {
        title: "Service Type",
        dataIndex: "service_type",
        key: "service_type",
        sorter: {
          compare: (a, b) => {
            a = a.service_type.toLowerCase();
            b = b.service_type.toLowerCase();
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      {
        title: "Current Supplier",
        dataIndex: "current_supplier",
        key: "current_supplier",
        sorter: {
          compare: (a, b) => {
            a = a.current_supplier.toLowerCase();
            b = b.current_supplier.toLowerCase();
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      // {
      //   title: "Source",
      //   dataIndex: "source",
      //   key: "source",
      //   sorter: {
      //     compare: (a, b) => {
      //       a = a.source.toLowerCase();
      //       b = b.source.toLowerCase();
      //       return a > b ? -1 : b > a ? 1 : 0;
      //     },
      //   },
      // },
      {
        title: "Postcode",
        dataIndex: "postcode",
        sorter: {
          compare: (a, b) => {
            a = a.postcode;
            b = b.postcode;
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      {
        title: "Contact Name",
        dataIndex: "contact_name",
        key: "contact_name",
        sorter: {
          compare: (a, b) => {
            a = a.contact_name.toLowerCase();
            b = b.contact_name.toLowerCase();
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      // {
      //   title: "Contact Email",
      //   dataIndex: "contact_email",
      //   sorter: {
      //     compare: (a, b) => {
      //       a = a.contact_email.toLowerCase();
      //       b = b.contact_email.toLowerCase();
      //       return a > b ? -1 : b > a ? 1 : 0;
      //     },
      //   },
      // },
      {
        title: "Contact Number",
        dataIndex: "contact_number",
        sorter: {
          compare: (a, b) => {
            a = a.contact_number;
            b = b.contact_number;
            return a > b ? -1 : b > a ? 1 : 0;
          },
        },
      },
      // {
      //   title: "Status",
      //   dataIndex: "status",
      //   key: "Status",
      //   sorter: {
      //     compare: (a, b) => {
      //       a = a.status;
      //       b = b.status;
      //       return a > b ? -1 : b > a ? 1 : 0;
      //     },
      //   },
      // },
      {
        title: "Action",
        dataIndex: "Action",
        key: "action",
      },
    ]);


    if (props.isAssigned) {

      columns.value.splice(0, 1);

      const assignColumns = [
        {
          title: "Assign To",
          dataIndex: "assign_to",
          key: "assign_to",
          sorter: {
            compare: (a, b) => a.assign_to.localeCompare(b.assign_to),
          },
        },
        {
          title: "Assign By",
          dataIndex: "assign_by",
          key: "assign_by",
          sorter: {
            compare: (a, b) => a.assign_by.localeCompare(b.assign_by),
          },
        },
        {
          title: "Assign Date",
          dataIndex: "assign_at",
          key: "assign_at",
          sorter: {
            compare: (a, b) => new Date(a.assign_at) - new Date(b.assign_at),
          },
        },
      ];

      // Insert at index 1
      columns.value.splice(1, 0, ...assignColumns);

      const assignColumns1 = [
        {
          title: "Organisation no.",
          dataIndex: "organization_number",
          key: "organization_number",
          sorter: {
            compare: (a, b) => {
              a = a.organization_number;
              b = b.organization_number;
              return a > b ? -1 : b > a ? 1 : 0;
            },
          },
        },
        {
          title: "Opportunity no.",
          dataIndex: "opportunity_number",
          key: "opportunity_number",
          sorter: {
            compare: (a, b) => a.opportunity_number.localeCompare(b.assign_by),
          },
        }
      ]

      // Insert at index 1
      columns.value.splice(5, 0, ...assignColumns1);
    }

    if (props.isClosed) {
      columns.value = [
        { title: "Lead No.", dataIndex: "lead_no", key: "lead_no", sorter: { compare: (a, b) => (a.lead_no > b.lead_no ? -1 : b.lead_no > a.lead_no ? 1 : 0) } },
        { title: "Created At", dataIndex: "created_at", key: "created_at", sorter: { compare: (a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0) } },
        { title: "Organisation Name", dataIndex: "organisation_name", key: "OrgName", sorter: { compare: (a, b) => (a.organisation_name || '').toLowerCase().localeCompare((b.organisation_name || '').toLowerCase()) } },
        { title: "Service Type", dataIndex: "service_type", key: "service_type", sorter: { compare: (a, b) => (a.service_type || '').toLowerCase().localeCompare((b.service_type || '').toLowerCase()) } },
        { title: "Current Supplier", dataIndex: "current_supplier", key: "current_supplier", sorter: { compare: (a, b) => (a.current_supplier || '').toLowerCase().localeCompare((b.current_supplier || '').toLowerCase()) } },
        { title: "Postcode", dataIndex: "postcode", key: "postcode", sorter: { compare: (a, b) => (a.postcode || '').localeCompare(b.postcode || '') } },
        { title: "Contact Name", dataIndex: "contact_name", key: "contact_name", sorter: { compare: (a, b) => (a.contact_name || '').toLowerCase().localeCompare((b.contact_name || '').toLowerCase()) } },
        { title: "Contact Number", dataIndex: "contact_number", key: "contact_number", sorter: { compare: (a, b) => (a.contact_number || '').localeCompare(b.contact_number || '') } },
        { title: "Closed By", dataIndex: "closed_by_name", key: "closed_by_name", sorter: { compare: (a, b) => (a.closed_by_name || '').localeCompare(b.closed_by_name || '') } },
        { title: "Reason Closed", dataIndex: "closed_reason", key: "closed_reason", sorter: { compare: (a, b) => (a.closed_reason || '').localeCompare(b.closed_reason || '') } },
        { title: "Date Closed", dataIndex: "closed_at", key: "closed_at", sorter: { compare: (a, b) => new Date(a.closed_at || 0) - new Date(b.closed_at || 0) } },
        { title: "Action", dataIndex: "Action", key: "action" },
      ];
    }

    const row = ref([])
    const allData = ref([])

    // Fields to remove
    const fieldsToRemove = new Set([
      "id",
      "request_id",
      "company_id",
      "created_at",
      "updated_at",
      "territory_id",
      "request_payload"
    ]);

    const pageSizeOptions = computed(() => {
      let options = [10]; // Default option
      if (pagination.value.total > 10) options.push(20);
      if (pagination.value.total > 20) options.push(50);
      if (pagination.value.total > 50) options.push(100);
      return options;
    });

    const fetchLeadsData = async (page) => {
      if (typeof page === 'number' && Number.isFinite(page)) {
        pagination.value.current = page;
      }
      const params = {
        page: pagination.value.current,
        pageSize: pagination.value.pageSize,
        // start_date: changeFormate(props.filters?.start_date).substring(0, 10) || null,
        // end_date: changeFormate(props.filters?.end_date).substring(0, 10) || null,
        start_date: formateDate(props.filters?.date?.[0]),
        end_date: formateDate(props.filters?.date?.[1]),
        assign_to: props.filters?.assign_to,
        assign_by: props.filters?.assign_by,
      };
      if (props.manualLeads) {
        params.manual_leads = 1;
      }
      let response;
      if (props.isClosed) {
        params.sort_field = props.filters?.sort_field || 'closed_at';
        params.sort_order = props.filters?.sort_order || 'desc';
        if (props.filters?.closed_by) params.closed_by = props.filters.closed_by;
        if (props.filters?.closed_reason) params.closed_reason = props.filters.closed_reason;
        response = await store.dispatch('leads/fetchClosedLeads', params);
      } else if (props.isAssigned) {
        response = await store.dispatch('leads/fetchAssignedLeads', params);
      } else {
        response = await store.dispatch('leads/fetchLeads', params);
      }

      const list = response?.data?.data ?? response?.data ?? [];
      const total = response?.data?.total ?? response?.total ?? 0;
      allData.value = list;

      if (props.isClosed) {
        data.value = list.map((lead) => ({
          lead_no: lead.lead_number,
          created_at: lead.created_at ? lead.created_at.substring(0, 10) : lead.created_at,
          key: lead.id,
          organisation_name: lead.company,
          service_type: lead.service_type,
          current_supplier: lead.current_supplier,
          postcode: lead.postcode,
          contact_name: lead.name,
          contact_number: formatPhoneNumber(lead.phone) || lead.phone,
          closed_by_name: lead.closed_by_name,
          closed_reason: lead.closed_reason,
          closed_at: lead.closed_at ? lead.closed_at.substring(0, 10) : lead.closed_at,
        }));
      } else if (response?.data) {
        data.value = list.map((lead) => ({
          sr_no: lead?.sr_no,
          lead_no: lead.lead_number,
          created_at: lead.created_at ? lead.created_at.substring(0, 10) : lead.created_at,
          key: lead.id,
          organisation_name: lead.company,
          service_type: lead.service_type,
          current_supplier: lead.current_supplier,
          source: lead.source,
          contact_number: lead.phone,
          contact_email: lead.email,
          contact_name: lead.name,
          postcode: lead.postcode,
          phone: formatPhoneNumber(lead.phone),
          status: lead.status,
          assign_by: lead.assign_by,
          assign_to: lead.assign_to,
          assign_at: lead.assign_at ? lead.assign_at.substring(0, 10) : lead.assign_at,
          organization_number: lead?.organization_number,
          opportunity_number: lead?.opportunity_number
        }));
      }
      pagination.value.total = total;
    };

    watch(
      () => props.manualLeads,
      () => {
        // Route switch between Leads and Manual leads reuses component instance;
        // force a refetch with page reset.
        pagination.value.current = 1;
        fetchLeadsData(1);
      }
    );

    const formatPhoneNumber = (number) => {
      if (!number) {
        return ''; // Return an empty string if the input is empty or undefined
      }

      const cleaned = number.replace(/\D/g, '');

      // Check if the cleaned number is valid (e.g., 10 digits)
      if (cleaned.length === 10) {
        return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
      } else {
        // Optionally, return a placeholder or the original input if not valid
        return number; // Or return a default placeholder like 'Invalid number'
      }
    };

    const handleTableChange = (current, pageSize) => {
      pagination.value.current = current;
      pagination.value.pageSize = pageSize;
      fetchLeadsData();
    };

    const viewMore = (id) => {
      const data = allData.value.find(item => item.id === id)
      // Convert keys by replacing _ with space and capitalizing each word
      const formatKey = (key) =>
        key
          .split("_")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

      // Transform and reorder object to place "Sr No" first
      const entries = Object.entries(data)
        .filter(([key]) => !fieldsToRemove.has(key)) // Remove unwanted fields
        .map(([key, value]) => [formatKey(key), value]); // Format keys

      // Sort to ensure "Sr No" is first
      entries.sort(([keyA], [keyB]) => (keyA === "Sr No" ? -1 : keyB === "Sr No" ? 1 : 0));

      // Convert back to object
      const transformedData = Object.fromEntries(entries);

      row.value = transformedData
      const modal = new Modal(document.getElementById("lead_model"));
      modal.show();
    }

    const cancel_change = () => {
      document.getElementById("close-btn").click()
    }

    const closeLeadModalEl = ref(null);
    const closeForm = ref({ lead_id: '', closed_reason: '' });
    const leadClosedReasons = ref([]);

    const editLeadModalEl = ref(null);
    const editForm = ref({
      lead_id: '',
      company: '',
      postcode: '',
      name: '',
      phone: '',
      email: '',
      gas: '',
      electricity: '',
      contract_end_date: '',
      address: '',
      service_type: '',
      current_supplier: '',
      source: '',
    });

    const createLeadModalEl = ref(null);
    const emptyLeadFormFields = () => ({
      company: '',
      postcode: '',
      name: '',
      phone: '',
      email: '',
      gas_list: [emptyMeterRow()],
      electricity_list: [emptyMeterRow()],
      contract_end_date: '',
      address: '',
      service_type: '',
      current_supplier: '',
      source: '',
    });
    const createForm = ref(emptyLeadFormFields());

    const openCloseModal = async (leadId) => {
      closeForm.value = { lead_id: leadId, closed_reason: '' };
      leadClosedReasons.value = await store.dispatch('leads/fetchLeadClosedReasons');
      if (closeLeadModalEl.value) {
        const modal = new Modal(closeLeadModalEl.value);
        modal.show();
      }
    };

    const closeCloseModal = () => {
      if (closeLeadModalEl.value) {
        const modal = Modal.getInstance(closeLeadModalEl.value);
        if (modal) modal.hide();
      }
      closeForm.value = { lead_id: '', closed_reason: '' };
    };

    const submitCloseLead = async () => {
      if (!closeForm.value.closed_reason || !closeForm.value.lead_id) return;
      try {
        await store.dispatch('leads/closeLead', {
          lead_id: closeForm.value.lead_id,
          closed_reason: closeForm.value.closed_reason,
        });
        closeCloseModal();
        await fetchLeadsData();
      } catch (_) { }
    };

    const handleUnassign = async (leadId) => {
      const result = await Swal.fire({
        title: 'Unassign lead?',
        text: 'It will go back to the unassigned pool.',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Unassign',
        cancelButtonText: 'Cancel',
      });
      if (!result.isConfirmed) return;
      try {
        await store.dispatch('leads/unassignClosedLead', { lead_id: leadId });
        await fetchLeadsData();
      } catch (_) {}
    };

    const openEditModal = (leadId) => {
      editErrors.value = {};
      const lead = allData.value.find(item => item.id === leadId);
      if (!lead) return;
      editForm.value = {
        lead_id: lead.id,
        company: lead.company || '',
        postcode: lead.postcode || '',
        name: lead.name || '',
        phone: lead.phone || '',
        email: lead.email || '',
        gas: meterValueToSingleFieldString(lead.gas),
        electricity: meterValueToSingleFieldString(lead.electricity),
        contract_end_date: (lead.contract_end_date || '').substring(0, 10),
        address: lead.address || '',
        service_type: lead.service_type || '',
        current_supplier: lead.current_supplier || '',
        source: lead.source || '',
      };
      if (editLeadModalEl.value) {
        const modal = new Modal(editLeadModalEl.value);
        modal.show();
      }
    };

    const closeEditModal = () => {
      if (editLeadModalEl.value) {
        const modal = Modal.getInstance(editLeadModalEl.value);
        if (modal) modal.hide();
      }
      editErrors.value = {};
      editForm.value = {
        lead_id: '',
        company: '',
        postcode: '',
        name: '',
        phone: '',
        email: '',
        gas: '',
        electricity: '',
        contract_end_date: '',
        address: '',
        service_type: '',
        current_supplier: '',
        source: '',
      };
    };

    const submitEditLead = async () => {
      if (!editForm.value.lead_id) return;
      editErrors.value = {};
      const payload = {};
      Object.entries(editForm.value).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          payload[key] = value;
        }
      });
      try {
        const res = await store.dispatch('leads/updateLead', payload);
        const { fieldErrors } = normalizeBackendErrors(res);
        if (Object.keys(fieldErrors).length) {
          editErrors.value = fieldErrors;
          return;
        }
        closeEditModal();
        await fetchLeadsData();
      } catch (error) {
        const { fieldErrors, message: backendMsg } = normalizeBackendErrors(error);
        if (Object.keys(fieldErrors).length) {
          editErrors.value = fieldErrors;
          return;
        }
        if (backendMsg) message.error(backendMsg);
      }
    };

    const openCreateModal = () => {
      createForm.value = emptyLeadFormFields();
      createErrors.value = {};
      if (createLeadModalEl.value) {
        const modal = new Modal(createLeadModalEl.value);
        modal.show();
      }
    };

    const closeCreateModal = () => {
      if (createLeadModalEl.value) {
        const modal = Modal.getInstance(createLeadModalEl.value);
        if (modal) modal.hide();
      }
      createErrors.value = {};
      createForm.value = emptyLeadFormFields();
    };

    const submitCreateLead = async () => {
      createErrors.value = {};
      const skip = new Set(['gas_list', 'electricity_list']);
      const payload = {};
      Object.entries(createForm.value).forEach(([key, value]) => {
        if (skip.has(key)) return;
        if (value !== '' && value !== null && value !== undefined) {
          payload[key] = value;
        }
      });
      const gasArr = meterListToPayloadArray(createForm.value.gas_list);
      const elecArr = meterListToPayloadArray(createForm.value.electricity_list);
      const gasDetailedArr = meterListToDetailedPayloadArray(createForm.value.gas_list);
      const elecDetailedArr = meterListToDetailedPayloadArray(createForm.value.electricity_list);
      if (gasArr.length) payload.gas = gasArr;
      if (elecArr.length) payload.electricity = elecArr;
      if (gasDetailedArr.length) payload.gas_details = gasDetailedArr;
      if (elecDetailedArr.length) payload.electricity_details = elecDetailedArr;
      try {
        const res = await store.dispatch('leads/createLead', payload);
        const { fieldErrors } = normalizeBackendErrors(res);
        if (Object.keys(fieldErrors).length) {
          createErrors.value = fieldErrors;
          return;
        }
        closeCreateModal();
        await fetchLeadsData();
      } catch (error) {
        const { fieldErrors, message: backendMsg } = normalizeBackendErrors(error);
        if (Object.keys(fieldErrors).length) {
          createErrors.value = fieldErrors;
          return;
        }
        if (backendMsg) message.error(backendMsg);
      }
    };

    const formateDate = (dateString) => {
      let date
      if (!dateString) {
        date = new Date(props.date?.[0])
      } else {
        date = new Date(dateString);
      }
      if (isNaN(date.getTime())) {
        return null;
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');

      const formattedDate = `${yyyy}-${mm}-${dd}`;
      return formattedDate;
    };

    // watchEffect(() => {
    //     fetchLeadsData();
    // });

    return {
      data,
      pagination,
      fetchLeadsData,
      handleTableChange,
      pageSizeOptions,
      viewMore,
      row,
      cancel_change,
      allData,
      columns,
      formateDate,
      isUnassigned: !props.isAssigned && !props.isClosed,
      isClosed: props.isClosed,
      openCloseModal,
      closeCloseModal,
      submitCloseLead,
      handleUnassign,
      closeLeadModalEl,
      closeForm,
      leadClosedReasons,
      editLeadModalEl,
      editForm,
      openEditModal,
      closeEditModal,
      submitEditLead,
      createLeadModalEl,
      createForm,
      openCreateModal,
      closeCreateModal,
      submitCreateLead,
      createErrors,
      editErrors,
      fieldError,
      MAX_METERS,
      addMeterRow,
      removeMeterRow,
      supplierOptions,
      supplierSelectSettingsForEdit,
      supplierSelectSettingsForCreate,
    };
  },
};
</script>
<style>
.lead-model {
  max-width: 800px !important;
}

.meter-add-slot {
  width: 2.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meter-add-btn {
  padding: 0.25rem 0.4rem;
}

.utility-input-col {
  flex: 1 1 0;
  min-width: 140px;
}

.utility-supplier-col {
  flex: 1 1 0;
  min-width: 170px;
}

.utility-date-col {
  flex: 0 0 150px;
}

.utility-remove-col {
  width: 2.125rem;
}
</style>

